<template>
    <div class="flex max-xl:flex-col">
      <div class="w-[400px] my-4 max-xl:mx-auto max-xl:max-w-full">
        <div class="bg-white rounded-[4px]">
          <div class="p-5 v-bbgray flex items-center justify-center">
            <div
              v-if="agent.active == 0"
              title="Сотрудник уволен!"
              class="w-5 h-5 mr-4"
            >
              <svg class="w-full h-full fill-status-11">
                <use xlink:href="@/assets/i.svg#status-11"></use>
              </svg>
            </div>
            <h2 class="uppercase text-center text-xl font-latobold">
              {{ agent.name }} {{ agent.secondname }}
            </h2>
          </div>
          <div class="p-5 v-bbgray">
            <div
              class="flex text-base text-zinc-800 font-latobold flex-col items-center"
            >
              <div
                class="w-48 h-48 my-5 mx-auto bg-green-500 overflow-hidden relative"
              >
                <span class="avatar w-full h-full">
                  <img
                    v-if="agent.picture"
                    class="w-full h-full object-cover"
                    :src="
                      'https://api.tahocrm.ru/uploads/users/mini/' +
                      agent.picture
                    "
                  />
                </span>
              </div>
            </div>
          </div>
          <div
        class="bg-white flex relative rounded-[8px] items-start self-start mt-4 w-full"
      >
        <div class="flex relative group p-1 px-4 v-bbgray w-full">
          <div v-if="choosenManager.name" class="flex justify-between">
            <div class="flex items-center cursor-pointer group">
              <div
                class="min-w-[1.5rem] w-11 h-11 rounded-full mr-4 text-clip overflow-hidden bg-green-500"
              >
                <span class="w-6 h-6">
                  <IcoPic
                    :pic="choosenManager?.picture"
                    :name="choosenManager?.name"
                  />
                </span>
              </div>
              <div class="flex flex-col justify-center text-clip overflow-hidden pr-8">
                <span
                  class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                  >Назначенный Менеджер</span
                >
                <span
                  class="font-latobold text-base group-hover:text-green-500 transition-colors duration-300"
                  >{{ choosenManager?.name }}
                  {{ choosenManager?.secondname }}</span
                >
              </div>
            </div>
            <div
              class="absolute top-1/2 -translate-y-1/2 right-4 opacity-0 group-hover:opacity-100 transition-all duration-150"
            >
              <a class="group cursor-pointer" @click="choosenManager = {}">
                <svg
                  class="fill-gray-400 w-4 h-4 cursor-pointer hover:fill-rose-500 transition-colors duration-150"
                >
                  <use xlink:href="@/assets/i.svg#ico-no"></use>
                </svg>
              </a>
            </div>
          </div>
  
          <template v-else>
            <div class="flex items-center w-full ">
              <p
                class="text-gray-400 leading-none w-full  mr-6"
              >
                Назначенный Менеджер
              </p>
              <div class="relative min-w-[250px]">
                <input
                  type="text"
                  v-model.trim="text_manager"
                  class="bg-white h-9 px-3 py-1 w-full box-border v-bgray rounded-sm text-sm text-teal-700"
                  @input="findManager()"
                  @click="findManager()"
                />
                <hr />
                <div
                  v-if="managerList.length"
                  class="absolute w-full top-full bg-white left-0 bor align-middleder-2 border-green-800 border-t-0 z-10"
                >
                  <div
                    v-for="m in managerList"
                    :key="m"
                    @click="setManager(m)"
                    class="px-4 py-1 flex justify-between hover:text-green-500 cursor-pointer hover:shadow-md transition-all duration-300"
                  >
                    <span>{{ m.secondname }} {{ m.name }}</span>
                    <span class="text-xs">{{ m.uid }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
          <div class="p-5 v-bbgray">
            <div class="flex my-1 items-center">
              <svg class="w-5 h-5 mr-4">
                <use xlink:href="@/assets/i.svg#ico-world-line"></use>
              </svg>
              <div class="flex">
                <span class="font-latobold mr-2">Логин:</span>
                <span>{{ agent.username }}</span>
              </div>
            </div>
  
            <div class="flex my-1 items-center">
              <svg class="w-5 h-5 mr-4">
                <use xlink:href="@/assets/i.svg#ico-question-line"></use>
              </svg>
              <div v-if="role == 'Studio' || role == 'Hosd'" class="flex">
                <span class="font-latobold mr-2">Пароль:</span>
                <span>{{ agent.pass }}</span>
              </div>
              <div v-else class="font-latobold">Пароль: зашифрован</div>
            </div>
  
            <div class="flex my-1 items-center">
              <svg class="w-5 h-5 mr-4">
                <use xlink:href="@/assets/i.svg#ico-question-line"></use>
              </svg>
              <div class="flex">
                <span class="font-latobold mr-2">Активность:</span>
                <span v-if="agent.active == 10">Активен</span>
                <span v-if="agent.active == 0">Неактивен</span>
              </div>
            </div>
          </div>
  
          <div class="p-5 v-bbgray">
            <div class="flex items-center">
              <svg class="w-5 h-5 mr-4">
                <use xlink:href="@/assets/i.svg#ico-mail"></use>
              </svg>
              <div class="flex items-center">
                <span class="font-latobold mr-2 w-16">E-mail:</span>
                <!-- <span>{{ worker.email }}</span> -->
                <label>
                  <input
                    type="text"
                    class="bg-slate-50 h-9 px-3 py-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                    name="sum"
                    v-model="agent.email"
                    @change="changethisAgent()"
                  />
                </label>
              </div>
            </div>
            <div class="flex mt-3 items-center">
              <svg class="w-5 h-5 mr-4">
                <use xlink:href="@/assets/i.svg#ico-phone"></use>
              </svg>
              <div class="flex items-center">
                <span class="font-latobold mr-2 w-16">Телефон:</span>
                <label>
                  <input
                    type="text"
                    class="bg-slate-50 h-9 px-3 py-2 w-full v-bgray rounded-sm text-sm text-teal-700"
                    name="sum"
                    v-model="agent.phone"
                    @change="changethisAgent()"
                  />
                </label>
              </div>
            </div>
            <div v-if="agent.fb" class="flex my-1 items-center">
              <svg class="w-5 h-5 mr-4">
                <use xlink:href="@/assets/i.svg#ico-avatar"></use>
              </svg>
              <div class="flex">
                <span class="font-latobold mr-2">FB:</span>
                <span>{{ agent.fb }}</span>
              </div>
            </div>
            <div v-if="agent.tl" class="flex my-1 items-center">
              <svg class="w-5 h-5 mr-4">
                <use xlink:href="@/assets/i.svg#ico-avatar"></use>
              </svg>
              <div class="flex">
                <span class="font-latobold mr-2">TL:</span>
                <span>{{ agent.tl }}</span>
              </div>
            </div>
          </div>
  
          <div class="p-4 v-bbgray">
            <h3 class="ml-4 mb-4 uppercase text-base font-latobold">Роли</h3>
            <template v-for="(rl, key) in r" :key="rl">
              <div
                class="v-btn bg-gray-500 hover:bg-gray-400 w-full flex justify-center items-center my-2"
                :class="{
                  '!bg-green-500 hover:!bg-green-400': agentRoles.includes(key),
                }"
                @click="onOffRole(key)"
              >
                <p
                  class="flex cursor-pointer group text-green-500 hover:text-green-400 transition-colors duration-150"
                >
                  <span class="v-btn_text">{{ rl }}</span>
                </p>
              </div>
            </template>
          </div>
  
          <div class="p-4 v-bbgray flex justify-center">
            <template v-if="agentRoles.includes('Master')">
              <a class="v-btn v-btn--sky v-btn--sm mx-2" @click="agentCal">
                <svg class="w-5 h-5 fill-white mr-2">
                  <use xlink:href="@/assets/i.svg#nav-calendar"></use>
                </svg>
                <span class="v-btn_text">Смены</span>
              </a>
            </template>
  
            <template
              v-if="(role == 'Studio' || role == 'Hosd') && agent.active != 0"
            >
              <a
                class="v-btn v-btn--rose v-btn--sm mx-2"
                @click="delAgent(agent)"
              >
                <svg class="w-5 h-5 fill-white mr-2">
                  <use xlink:href="@/assets/i.svg#ico-delete"></use>
                </svg>
                <span class="v-btn_text">Уволить</span>
              </a>
            </template>
  
            <template
              v-if="(role == 'Studio' || role == 'Hosd') && agent.active == 0"
            >
              <a
                class="v-btn v-btn--green v-btn--sm mx-2"
                @click="delAgent(agent)"
              >
                <span class="v-btn_text">Восстановить</span>
              </a>
            </template>
          </div>
        </div>
      </div>
      </div>
  </template>
  
  <script>
  import API from "@/services/api";
  import { mapActions, mapGetters } from "vuex";

  export default {
    name: "AgentView",
  
    data() {
      return {
        mnths: [
          "",
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь",
        ],
        r: {
          Manager: "Менеджер",
          Logist: "Логист",
          Studio: "Директор",
          Master: "Инженер",
          Check: "Контроль качества",
          Finance: "Финансист",
          Assistant: "Асистент",
          Buh: "Бухгалтер",
          Outsourcer: "Подрядчик",
          Hosd: "Руководитель ОП",
          Agent: "Агент"
        },
        cats: [],
        master: {},
        text_manager: "",
        choosenManager: {},
        managerList: [],
      };
    },
  
    computed: {
      ...mapGetters([
        "s",
        "profile",
        "role",
        "roles",
        "roleNames",
        "agent",
        "agentCats",
        "selectManagers"
      ]),
  
      agentRoles() {
        if (this.agent.roles) {
          return this.agent.roles.map((e) => e.item_name);
        }
        return [];
      },
    },
  
    methods: {
      ...mapActions([
        "getAgent",
        "delAgent",
        "onOffRole",
        "ChangeCat",
        "setCalType",
        "getCal",
        "changeAgent",
        'profile',
        'getSelects'
      ]),
        setManager(manager) {
        this.choosenManager = manager;
        console.log(this.selectManagers)

        const formData = new FormData()
        formData.append('manager_id', this.choosenManager.uid)
        formData.append('uid', this.agent.uid)
        API.POST("worker/set-manager", formData)
      },
      findManager() {
        console.log("findMaster", this.selectManagers);
        this.managerList = this.selectManagers.filter(
          (item) =>
            item.name.toLowerCase().indexOf(this.text_manager.toLowerCase()) !==
            -1
        );
      },
      agentCal() {
        this.setCalType(5);
        this.getCal();
        this.$router.push("/calendar");
      },
      changethisAgent() {
        this.changeAgent({
          uid: this.agent.uid,
          email: this.agent.email,
          phone: this.agent.phone,
        });
      },
    },
  
    async mounted() {
  await this.getAgent();
  await this.getSelects()
  if (this.agent.manager_id != null) {
    console.log('менеджер есть!', this.agent.manager_id )

    this.choosenManager = this.selectManagers.find((item) => {
      if (item.uid === this.agent.manager_id) {
        console.log('искомый менеджер!', this.agent.manager_id )
        console.log('менеджер нашелся!', item.uid )
        return true;
      }
      return false;
    });
  }
},
  };
  </script>
  